<div class="bottom-bar" [ngClass]="{'mobile': sharedDataService.isHandset$ | async}">
  <div class="employee-login">
    @if (isLoggedIn()) {
      <button mat-button (click)="openChangePassword()">Passwort ändern</button>
      <button mat-button (click)="logout()">Ausloggen</button>
    }
  </div>
  <div class="legal">
    <a [href]="constants.supportEmail">Support</a>
    <a [href]="constants.termsAndConditions">AGB</a>
    <a [href]="constants.imprint">Impressum</a>
    <a [href]="constants.privacyStatement">Datenschutzerklärung</a>
    <a [href]="constants.licenses">Lizenzen</a>
    <a routerLink="/changelog">Changelog</a>
  </div>
  <p class="version">NeoClinic by aiddevs. Version: {{ version }}</p>
</div>
